import { type SxProps, type Theme } from '@mui/material';

export const helpTabGroupLabelSx: SxProps<Theme> = {
  padding: '0.625rem 0.5rem 0.25rem',
  fontSize: '0.625rem',
  textTransform: 'uppercase',
  letterSpacing: '.08em',
  color: (theme) => theme.palette.custom.OV.sys.onSurfaceVariant,
  opacity: 0.8,
};

export const helpTabItemSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  gap: '0.625rem',
  width: '100%',
  height: '1.875rem',
  padding: '0 0.5rem',
  borderRadius: '0.375rem',
  color: (theme) => theme.palette.custom.OV.sys.onSurface,
  fontSize: '0.78125rem',
  textAlign: 'left',
  cursor: 'pointer',
  transition: 'color 0.1s ease-in-out, background-color 0.1s ease-in-out',
  '&:hover': {
    color: (theme) => theme.palette.custom.OV.sys.inverseSurface,
    backgroundColor: (theme) => theme.palette.custom.OV.sys.surfaceContainerHighest,
  },
  '@media (hover: none)': {
    '&:hover': { backgroundColor: 'transparent' },
  },
};
